
import { defineComponent } from "vue";
import FlyingSpan from "./FlyingSpan.vue";

const activities = [
  {
    name: "Аудит",
    message: "если вы осуществляете",
  },
  {
    name: "Бухгалтерии",
    message: "если вы оказываете услуги",
  },
  {
    name: "Консалтингом",
    message: "если вы занимаетесь",
  },
  {
    name: "Колл-центрам",
    message: "если вы оказываете услуги",
  },
  {
    name: "Фрилансер",
    message: "если вы работаете как",
  },
];

const startTimeout = 2000;

export default defineComponent({
  components: { FlyingSpan },
  name: "TheTopFakeInput",
  data: () => ({
    activity: 0,
    name: "",
    isFlipping: false,
    message: "если вы",
  }),
  methods: {
    reprint() {
      const currentFullName = activities[this.activity].name;
      const timeofupdate = 500 / currentFullName.length;
      for (let i = 1; i <= currentFullName.length; i += 1) {
        setTimeout(() => {
          this.name = currentFullName.substr(0, currentFullName.length - i);
        }, timeofupdate * i);
      }
      setTimeout(() => {
        this.print();
      }, currentFullName.length * timeofupdate);

      const nextActivityIdx = this.activity + 1 >= activities.length ? 0 : this.activity + 1;
      this.activity = nextActivityIdx;
    },
    print() {
      const fullName = activities[this.activity].name;
      const timeofupdate = 500 / fullName.length;
      this.isFlipping = true;
      setTimeout(() => {
        this.message = activities[this.activity].message;
      }, 250);
      setTimeout(() => {
        this.isFlipping = false;
      }, 500);
      for (let i = 1; i <= fullName.length; i += 1) {
        setTimeout(() => {
          this.name = fullName.substr(0, i);
        }, timeofupdate * i);
      }
    },
  },
  mounted() {
    setTimeout(() => {
      this.print();
      setInterval(() => {
        this.reprint();
      }, 3000);
    }, startTimeout);
  },
});
